<template>
  <div class=" gerenzhongxinshezhi" style="margin-top
  :30px;height:100%">
    <n-tabs type="line" :tab-style="{ fontSize: '22px' }">
      <n-tab-pane :name="0" tab="用户名修改">
        <div style="width: 600px;margin-top:20px;" class="mt-1">
          <n-input class="w-full" style="font-size:20px;height:50px;line-height: 50px;" v-model:value="username"
            placeholder="请输入新用户名（6至20个字符）" />
          <div class="flex justify-center" style="margin-top:26px;">
            <el-button class="px-10 mt-6 allbtncolor" type="primary" :loading="usernameLoading"
              @click="handleUsernameEdit">
              修 改
            </el-button>
          </div>
        </div>
      </n-tab-pane>
      <n-tab-pane :name="1" tab="密码修改">
        <n-form :model="editPasswordModal" ref="passwordFormRef" :rules="passwordRules" label-width="80px"
          require-mark-placement="left" label-placement="left" size="large" style="margin-top:20px;width: 600px"
          class="mt-1">
          <n-form-item path="oldPassWord" label="旧密码" label-width="120px">
            <n-input style="font-size:20px;height:50px;line-height: 50px;" v-model:value="editPasswordModal.oldPassWord"
              @keydown.enter.prevent />
          </n-form-item>
          <n-form-item path="newPassWord" label="新密码" label-width="120px">
            <n-input style="font-size:20px;height:50px;line-height: 50px;" v-model:value="editPasswordModal.newPassWord"
              type="password" @keydown.enter.prevent />
          </n-form-item>
          <n-form-item first path="newPassWord2" label="确认密码" label-width="120px">
            <n-input style="font-size:20px;height:50px;line-height: 50px;"
              v-model:value="editPasswordModal.newPassWord2" type="password" @keydown.enter.prevent />
          </n-form-item>
          <div class="flex justify-center">
            <el-button :loading="passwordLoading" class="px-10 allbtncolor" type="primary" @click="handlePasswordEdit">
              修 改
            </el-button>
          </div>
        </n-form>
      </n-tab-pane>
      <n-tab-pane :name="2" tab="手机号码修改" display-directive="show">
        <div style="width: 600px;margin-top:20px;" class="mt-1">
          <n-form :model="editPhoneModal" ref="editPhoneFormRef" :rules="editPhoneRules" label-width="80px"
            require-mark-placement="left" label-placement="left" size="large" style="width: 600px" class="mt-1">
            <n-form-item label="新手机号" path="phone" ref="phoneRef" label-width="120px">
              <n-input placeholder="请输入新手机号" style="font-size:20px;height:50px;line-height: 50px;"
                v-model:value="editPhoneModal.phone" />
            </n-form-item>
            <n-form-item label="验证码" path="verificationCode" label-width="120px">
              <n-input-group>
                <n-input v-model:value="editPhoneModal.verificationCode"
                  style="font-size:20px;height:50px;line-height: 50px;" placeholder="请输入验证码" class="w-full" />
                <el-button size="large" class="serch_input_box_btn_fa" :disabled="verifyTime > 0" type="primary"
                  :loading="codeLoading" style="" @click="sendCode">
                  {{ verifyTime === 0 ? '发送验证码' : verifyTime + '秒后重试' }}
                </el-button>
              </n-input-group>
            </n-form-item>
            <div class="flex justify-center">
              <el-button :loading="phoneLoading" class="px-10 allbtncolor" type="primary" @click="handlePhoneEdit">
                修 改
              </el-button>
            </div>
          </n-form>
        </div>
      </n-tab-pane>
    </n-tabs>
    <div style="height:60px"></div>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue';
import { editUsernameApi, editPasswordApi, sendCodeApi, editPhoneApi } from '@/api';

const username = ref('');
const usernameLoading = ref(false);

async function handleUsernameEdit () {
  if (username.value.trim() === '') {
    return window.message.warning('请输入用户名');
  }
  if (!(username.value.length >= 6 && username.value.length <= 20)) {
    return window.message.warning('用户名长度6至20个字符');
  }
  usernameLoading.value = true;
  try {
    const res = await editUsernameApi(username.value);
    if (res.success) {
      window.message.success('修改成功');
    } else {
      throw new Error('修改失败');
    }
  } catch (err) {
    window.message.error(err || '修改失败');
  }
  usernameLoading.value = false;
}

const editPasswordModal = reactive({
  newPassWord: '',
  newPassWord2: '',
  oldPassWord: '',
});
const passwordFormRef = ref(null);
const passwordLoading = ref(false);
const passwordRules = {
  oldPassWord: [
    {
      required: true,
      trigger: ['input', 'blur'],
      message: '请输入原始密码',
    },
    {
      trigger: ['input', 'blur'],
      min: 6,
      max: 20,
      message: '请输入6~20个字符',
    },
  ],
  newPassWord: [
    {
      required: true,
      whitespace: true,
      trigger: ['input', 'blur'],
      message: '请输入密码',
    },
    {
      trigger: ['input', 'blur'],
      min: 6,
      max: 20,
      message: '密码长度为6~20个字符',
    },
  ],
  newPassWord2: [
    {
      required: true,
      whitespace: true,
      trigger: ['input', 'blur'],
      message: '请再次输入密码',
    },
    {
      trigger: ['input', 'blur'],
      min: 6,
      max: 20,
      message: '密码长度为6~20个字符',
    },
    {
      validator: validatePasswordStartWith,
      message: '两次密码输入不一致',
      trigger: 'blur',
    },
  ],
};

function validatePasswordStartWith (rule, value) {
  console.log('@@@@@@@@@@@@@@@');
  console.log(rule);
  console.log(value);
  return (
    editPasswordModal.newPassWord &&
    editPasswordModal.newPassWord.startsWith(value) &&
    editPasswordModal.newPassWord.length >= value.length
  );
}

function handlePasswordEdit (e) {
  e.preventDefault();
  passwordFormRef.value.validate(async errors => {
    if (errors) {
      return;
    }
    passwordLoading.value = true;
    try {
      const res = await editPasswordApi(editPasswordModal);
      if (res.success) {
        window.message.success('修改成功');
      } else {
        throw new Error(res.msg);
      }
    } catch (err) {
      window.message.error(err || '修改失败');
    }
    passwordLoading.value = false;
  });
}

const editPhoneModal = reactive({
  phone: '',
  verificationCode: '',
});
const editPhoneRules = {
  phone: [
    {
      required: true,
      trigger: ['input', 'blur'],
      message: '请输入新手机号',
      whitespace: true,
    },
    {
      // validator: validatePhone,
      pattern: /^1[3456789]\d{9}$/,
      message: '手机格式输入错误，请重新输入',
      trigger: 'blur',
    },
  ],
  verificationCode: {
    required: true,
    trigger: ['input', 'blur'],
    message: '请输入验证码',
    whitespace: true,
  },
};

function validatePhone (rule, value) {
  console.log(rule);
  return /^1[3456789]\d{9}$/.test(value);
}

const editPhoneFormRef = ref(null);
const phoneRef = ref(null);
const verifyTime = ref(0);
const codeLoading = ref(false);
const phoneLoading = ref(false);

function sendCode () {
  phoneRef.value.validate({
    trigger: 'blur',
    async callback (errors) {
      console.log(errors);
      if (errors) {
        return;
      }
      codeLoading.value = true;
      try {
        const res = await sendCodeApi(editPhoneModal.phone);
        codeLoading.value = false;
        if (res.success) {
          window.message.success('发送成功');
          // 发送验证码
          verifyTime.value = 60;
          let verifyTimer = setInterval(() => {
            if (verifyTime.value === 0) {
              clearInterval(verifyTimer);
              return;
            }
            verifyTime.value--;
          }, 1000);
        } else {
          throw new Error('发送失败');
        }
      } catch (err) {
        window.message.error(err || '修改失败');
        codeLoading.value = false;
      }
    },
  });
}

function handlePhoneEdit (e) {
  e.preventDefault();
  editPhoneFormRef.value.validate(async errors => {
    if (errors) {
      return;
    }
    phoneLoading.value = true;
    try {
      const res = await editPhoneApi(editPhoneModal);
      if (res.success) {
        window.message.success('修改成功');
      } else {
        throw new Error(res.msg);
      }
    } catch (err) {
      window.message.error(err || '修改失败');
    }
    phoneLoading.value = false;
  });
}
</script>
<style >
.gerenzhongxinshezhi .n-tabs-tab__label {
  color: #2d60f6;
}
.n-input__input-el::-webkit-input-placeholder {
  /* color: red; */
  /* font-size: 22px !important; */
}
.gerenzhongxinshezhi .n-form-item-label {
  font-size: 20px;
  line-height: 50px !important;
  height: 50px !important;
}
.gerenzhongxinshezhi .n-tabs-bar {
  background-color: #2d60f6;
  /* height: 6px; */
}
.gerenzhongxinshezhi .n-tabs-tab-pad {
  width: 70px;
}
/* input::-webkit-input-placeholder {
  font-size: 22px;
}
input::-moz-placeholder {

  font-size: 22px;
}
input:-moz-placeholder {

  font-size: 22px;
}
input:-ms-input-placeholder {

  font-size: 22px;
} */
</style>
<style >
.allbtncolor {
  margin-top: 20px;
}
</style>
<style scoped>
.serch_input_box_btn_fa {
  background-image: linear-gradient(to right, #235bf3, #5cacd2, #82e782);
  border: none;
  width: 220px !important;
  font-size: 16px;
}
</style>